import { useEffect } from 'react'
import { Button, Typography } from 'mobily-ui-library/lib';
import Close from '../../assets/Close.svg';
import Spinner from '../../assets/Spinner.svg';

import './CoverageCheck.scss';
import { useTranslation } from 'react-i18next';

interface Props {
    id: string;
    rtl: boolean;
    description?: string;
    loader: string;
    modalFirstButtonClick?: () => void;
}

function CoverageCheck({ rtl, id, description, loader, modalFirstButtonClick }: Props) {
    const { t } = useTranslation();

    useEffect(() => {
        document.body.style.overflow = 'hidden';
    }, []);

    return (
        <div className={rtl ? 'CC__ModalContainer CC__ModalRight' : 'CC__ModalContainer'}>
            <div className='CC__Fallback'></div>
            <div className='CC__Modal' id={id}>
                {loader && <div className='CC__Loading'>
                    <img src={Spinner} alt='Spinner' className='CC__Spinner'/>
                    <Typography rtl={rtl} className='CC__MST'>{description}</Typography>
                </div>}

                {!loader && <div className='CC__ModalContent'>
                    <div className='CC__header'>
                        <div></div>
                        <img src={Close} alt='Close' className='CC__Close' onClick={modalFirstButtonClick} />
                    </div>
                    <Typography rtl={rtl} className='CC__MST'>{t('Request_Location_Not_Supported')} </Typography>
                    <Button rtl={rtl} className='CC__MButton' onClick={modalFirstButtonClick}>{t('Got_it')}</Button>
                </div>}

            </div>
        </div>
    )
}

export default CoverageCheck